export default (function (context, factory) {

    return factory();

})(window, function () {


	/**
	 * @desc 时间日期控件
	 * @exports wx/storage
	 * @version 1.0.0
	 * @author maixingjie
	 * @copyright Copyright 2017-2027
	 * 
	 */
    var qt_model = {}

    qt_model.formatDig = function (num) {
        return num > 9 ? '' + num : '0' + num;
    }

    qt_model.formatDate = function (mill) {
        var y = new Date(mill);
        let raws = [
            y.getFullYear(),
            qt_model.formatDig(y.getMonth() + 1),
            qt_model.formatDig(y.getDate()),
            y.getDay() || 7
        ];
        let format = ['年', '月', '日 星期'];
        return String.raw({ raw: raws }, ...format);
    }


    qt_model.formatDateV2 = function (mill) {
        var y = new Date(mill);
        let raws = [
            y.getFullYear(),
            qt_model.formatDig(y.getMonth() + 1),
            qt_model.formatDig(y.getDate())
        ];
        let format = ['','',''];
        return String.raw({ raw: raws }, ...format);
    }

    qt_model.createWeeks = function* (year) {
        const ONE_DAY = 24 * 3600 * 1000;
        let start = new Date(year, 0, 1),
            end = new Date(year, 11, 31);
        let firstDay = start.getDay() || 7,
            lastDay = end.getDay() || 7;
        let startTime = +start,
            endTime = startTime + (7 - firstDay) * ONE_DAY,
            _endTime = end - (7 - lastDay) * ONE_DAY;
        yield [startTime, endTime];
        startTime = endTime + ONE_DAY;
        endTime = endTime + 7 * ONE_DAY;
        while (endTime < _endTime) {
            yield [startTime, endTime];
            startTime = endTime + ONE_DAY;
            endTime = endTime + 7 * ONE_DAY;
        }
        yield [startTime, +end];
    }


    qt_model.getYearWeek = function (date) {
        var date2 = new Date(date.getFullYear(), 0, 1);
        var day1 = date.getDay();
        if (day1 == 0) day1 = 7;
        var day2 = date2.getDay();
        if (day2 == 0) day2 = 7;
        d = Math.round((date.getTime() - date2.getTime() + (day2 - day1) * (24 * 60 * 60 * 1000)) / 86400000);
        return Math.ceil(d / 7) + 1;
    }

    /**
     * 获取某年的所有周
     */
    qt_model.initWeeks = function(year){
        let index=1;
        let _allArry = new Array();
        for(let i of qt_model.createWeeks(year)){
            let start=i[0],end=i[1];
            let _subArry = new Array();
            _subArry[0] = qt_model.formatDateV2(start);
            _subArry[1] = qt_model.formatDateV2(end);
            _allArry.push(_subArry);
        }
        return _allArry;
    }


    /*
      返回date所在日期的当周及下周日期数组
     *返回值'yyyy-mm-dd
     */
    qt_model.getCurrentWeekDays = function(joinSign='') {
        const dateOfToday = Date.now()
        const dayOfToday = (new Date().getDay() + 7 - 1) % 7
        const daysOfThisWeek = Array.from(new Array(7)).map((_, i) => {
            const date = new Date(dateOfToday + (i - dayOfToday) * 1000 * 60 * 60 * 24)
            return date.getFullYear() +
              joinSign +
              String(date.getMonth() + 1).padStart(2, '0') +
              joinSign +
              String(date.getDate()).padStart(2, '0')
          })
        return daysOfThisWeek
    }


    /**
     * 计算某日当周的时间段
     */
    qt_model.getWeekDays = function(opDate,joinSign='') {
        const dateOfToday = opDate.getTime()
        const dayOfToday = (opDate.getDay() + 7 - 1) % 7
        const daysOfThisWeek = Array.from(new Array(7)).map((_, i) => {
            const date = new Date(dateOfToday + (i - dayOfToday) * 1000 * 60 * 60 * 24)
            return date.getFullYear() +
              joinSign +
              String(date.getMonth() + 1).padStart(2, '0') +
              joinSign +
              String(date.getDate()).padStart(2, '0')
          })
        return daysOfThisWeek
    }



    /*
     *返回date所在日期的当周 的周一与周五的时间
     *返回值'yyyy-mm-dd
     */
    qt_model.getCurrentWeekDaysByMFList = function() {
        const dateOfToday = Date.now()
        const dayOfToday = (new Date().getDay() + 7 - 1) % 7
        const daysOfThisWeek = Array.from(new Array(5)).map((_, i) => {
            const date = new Date(dateOfToday + (i - dayOfToday) * 1000 * 60 * 60 * 24)
            return date.getFullYear() +
              '-' +
              String(date.getMonth() + 1).padStart(2, '0') +
              '-' +
              String(date.getDate()).padStart(2, '0')
          })
        return daysOfThisWeek
    }


    /**
     * 返回距离今天某日的时间
     */
    qt_model.getDifDate = function(daysAago=0){
        const dateOfToday = Date.now()
        return new Date(dateOfToday + daysAago * 1000 * 60 * 60 * 24)
    }
   

    // a: 年 b: 月  c: 日  （包括跟上个月重合的部分）
    qt_model.getMonthWeek = function(year,month, day) {
        const date = new Date(year, parseInt(month) - 1, day)
        // const w = date.getDay()
        const d = date.getDate()
        return Math.ceil(
          d / 7
        )
    }

    /**
     * 计算两个周之间相差值
     */
    qt_model.caulWeekDifVal = function(startWkday,endWkday){
        const startWkdate = qt_model.strToDate(startWkday)
        const endWkdate = qt_model.strToDate(endWkday)
        const d1 = startWkdate.getTime();
        const d2 = endWkdate.getTime()
        const val = (d2-d1) / (1000 * 60 * 60 * 24 * 7)  
        console.log("caulWeekDifVal:  "+startWkday+"   "+endWkday+" ==>  "+val);
        return val; 
    }


    qt_model.strToDate = function(str){
        const _y = str.substring(0,4);
        const _m = str.substring(4,6);
        const _d = str.substring(6,8);
        return new Date(parseInt(_y), parseInt(_m) - 1, parseInt(_d))
    }

    /*
      返回最近两周的时间
     *返回值'yyyy-mm-dd
     */
    qt_model.getLastTowWeeksDays = function(joinSign='') {
        const dateOfToday = Date.now()
        const dayOfToday = (new Date().getDay() + 7 - 1) % 7
        const daysOfThisWeek = Array.from(new Array(7)).map((_, i) => {
            const date = new Date(dateOfToday + (i - dayOfToday) * 1000 * 60 * 60 * 24)
            return date.getFullYear() +
              joinSign +
              String(date.getMonth() + 1).padStart(2, '0') +
              joinSign +
              String(date.getDate()).padStart(2, '0')
          })

        const dateOfToday_l = Date.now() - 7 * 24 * 3600 * 1000;
        const dayOfToday_l = (new Date().getDay() + 7 - 1) % 7
        const daysOfThisWeek_l = Array.from(new Array(7)).map((_, i) => {
        const date = new Date(dateOfToday_l + (i - dayOfToday_l) * 1000 * 60 * 60 * 24)
              return date.getFullYear() +
                joinSign +
                String(date.getMonth() + 1).padStart(2, '0') +
                joinSign +
                String(date.getDate()).padStart(2, '0')
        })

        let merge_array = daysOfThisWeek_l.concat(daysOfThisWeek)
        merge_array.reverse()
        return merge_array
    }


    /**
     * @desc 格式化日期
     * @param {long} datetime 毫秒数
     * @param {String} [style] 格式设置,默认yyyy-MM-dd
     * @return {String} 格式化后的日期
     */
    qt_model.formatDateV2 = function(datetime,style){
        var date = new Date(datetime);
        var _style = style?(''+style):'yyyy-MM-dd';
        var regMap = { 
            "M+" : date.getMonth() + 1, // month 
            "d+" : date.getDate(), // day 
            "h+" : date.getHours(), // hour 
            "m+" : date.getMinutes(), // minute 
            "s+" : date.getSeconds(), // second 
            "w+" : "天一二三四五六".charAt(date.getDay()), // week 
            "q+" : Math.floor((date.getMonth() + 3) / 3), // quarter 
            "S" : date.getMilliseconds() // millisecond 
        };
        if (/(y+)/.test(_style)) { 
            _style = _style.replace(RegExp.$1,(date.getFullYear() + "").substr(4 - RegExp.$1.length)); 
        }
        for(var _reg in regMap) { 
            if(new RegExp("("+ _reg +")").test(_style)) { 
                _style = _style.replace(RegExp.$1,RegExp.$1.length == 1 ? regMap[_reg] : ("00" + regMap[_reg]).substr(("" + regMap[_reg]).length)); 
            }
        }
        return _style; 
    }


    return qt_model;
});


// WEBPACK FOOTER //
// ./src/libs/qt/dateUtil.js